import type { RouteRecordRaw } from 'vue-router';

export const paymentsApprovalRoutes = [
  {
    path: 'payments-approval',
    name: 'payments-approval',
    component: () => import('./PaymentsApproval.vue'),
    meta: { title: 'Payments Approval' },
  },
] as const satisfies readonly RouteRecordRaw[];
